<iframe
  *ngIf="iframeUrl"
  class="iframe"
  scrolling="yes"
  [src]="iframeUrl"
></iframe>
